var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickActionMic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#E3E3E3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6193 17.337C16.4194 17.3349 17.8781 15.8761 17.8802 14.0761V9.51087C17.8802 7.70994 16.4203 6.25 14.6193 6.25C12.8184 6.25 11.3585 7.70994 11.3585 9.51087V14.0761C11.3606 15.8761 12.8193 17.3349 14.6193 17.337V17.337Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8367 12.7719C19.4765 12.7719 19.1845 13.0638 19.1845 13.424V14.0762C19.1845 16.5975 17.1406 18.6414 14.6193 18.6414C12.098 18.6414 10.0541 16.5975 10.0541 14.0762V13.424C10.0541 13.0638 9.76212 12.7719 9.40193 12.7719C9.04174 12.7719 8.74976 13.0638 8.74976 13.424V14.0762C8.75404 17.0635 10.9987 19.5722 13.9671 19.9073V23.2066H11.3585C10.9983 23.2066 10.7063 23.4986 10.7063 23.8588C10.7063 24.219 10.9983 24.511 11.3585 24.511H17.8802C18.2404 24.511 18.5324 24.219 18.5324 23.8588C18.5324 23.4986 18.2404 23.2066 17.8802 23.2066H15.2715V19.9073C18.2399 19.5722 20.4846 17.0635 20.4889 14.0762V13.424C20.4889 13.0638 20.1969 12.7719 19.8367 12.7719Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickActionMic);
export default __webpack_public_path__ + "static/media/quick_action_mic.3830494d62df74b234a870447c5a0690.svg";
export { ForwardRef as ReactComponent };